import { AccountsCard } from './AccountsCard.entity';
import { BalanceAccountChart } from './BalanceAccountChart.entity';
import { BalanceBankChart } from './BalanceBankChart.entity';
import { BalanceCard } from './BalanceCard.entity';

export class GeneralGroupData {
  constructor(
    public balanceCard: BalanceCard,
    public accountsCard: AccountsCard,
    public balanceBankChart: BalanceBankChart[],
    public balanceAccountChart: BalanceAccountChart[]
  ) {}
}
